// extracted by mini-css-extract-plugin
export default {"container":"ConnectionSearchingFor_container__G9luF","dotsAndHeadingWrapper":"ConnectionSearchingFor_dotsAndHeadingWrapper__JXvFf"};